export default "__VITE_ASSET__BbU05o4S__"